import React from "react";
import { Mousewheel, Navigation } from "swiper/modules";
// import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';

function SearchIcon() {
  return (
    <a
      href={`${globals.siteRoot}/search/`}
      className="search"
      aria-label="Open search form"
    >
      <i className="fa-solid fa-magnifying-glass"></i>
    </a>
  );
}

function Button(props) {
  return (
    <div className="GCFilters-button">
      <button
        className="Button"
        id="filterCards"
        onClick={props.handleButtonClick}
      >
        Filter
      </button>
    </div>
  );
}

function Filters(props) {
  return (
    <Swiper
      id="categoriesFilter"
      modules={[ Navigation, Mousewheel ]}
      wrapperTag="ul"
      slidesPerView="auto"
      spaceBetween={10}
      centeredSlides={false}
      pagination={{
        enabled: false,
      }}
      navigation={{
        enabled: true,
      }}
      freeMode={true}
      mousewheel={{
        enabled: true,
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity:    6,
      }}
    >
      {props.filters.map((term) => (
        <Filter
          term={term}
          key={term.term_id}
          filterDefined={props.filterDefined}
          handleFilterClick={props.handleFilterClick}
        />
      ))}
    </Swiper>
  );
}

const Filter = ({ term, filterDefined, handleFilterClick }) => {
  return (
    <SwiperSlide
      tag="li"
      className={term.slug === filterDefined ? "is-active" : ""}
      key={term.term_id}
      data-slug={term.slug}
      data-term-id={term.term_id}
      data-value={term.slug}
      onClick={handleFilterClick}
    >
      {term.name}
    </SwiperSlide>
  );
}

Filter.displayName = "SwiperSlide"; // Workaround

export default function GCFilters(props) {
  const filterDefined = window.location.href.indexOf("category=") > -1;
  const filters = globals.archiveFilters;
  let allTerms = [-1];

  function removeActiveClass() {
    [...document.querySelectorAll("#categoriesFilter li")].forEach((filter) => {
      filter.classList.remove("is-active");
    });
  }

  function handleButtonClick() {
    const filteredTerm = filterDefined
      ? window.location.href.split("category=")[1].split("&")[0]
      : "all";

    const categoryTerm = document.querySelector(
      `#categoriesFilter li[data-slug=${filteredTerm}]`
    );
    updateFilters(categoryTerm);
  }

  function handleFilterClick(e) {
    updateFilters(e.target);
  }

  function updateFilters(categoryTerm) {
    removeActiveClass();

    allTerms = [categoryTerm.dataset.termId];

    categoryTerm.classList.add("is-active");

    let url = window.location.href;
    let initialLoad = url.indexOf("&load") > -1;
    url = url.split("&load")[0];
    let page = initialLoad
      ? url.indexOf("page=") > -1
        ? url.split("page=")[1]
        : 1
      : 1;

    if (categoryTerm.value == "all" || categoryTerm.dataset.value == "0") {
      if (page > 1) {
        let newUrl = url.split("?page=")[0] + "?page=" + page;
        window.history.replaceState(null, null, newUrl);
      } else {
        let newUrl = url.split("?")[0];
        window.history.replaceState(null, null, newUrl);
      }
    } else {
      let newUrl =
        url.split("?")[0] +
        "?category=" +
        categoryTerm.dataset.value +
        "&page=" +
        page;
      window.history.replaceState(null, null, newUrl);
    }
    props.update && props.update({ terms: allTerms, page_num: page });
  }

  return (
    <div className="GCFilters">
      <div className="GCFilters-rail">
        <Filters
          filters={filters}
          filterDefined={filterDefined}
          handleFilterClick={handleFilterClick}
        />
        <SearchIcon />
        <Button handleButtonClick={handleButtonClick} />
      </div>
    </div>
  );
}
